
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftBottom0 as ObiThreewayStackedInleftBottom0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-bottom-0.js';
 
 
 

 
 export const ObiThreewayStackedInleftBottom0 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-bottom-0',
   elementClass: ObiThreewayStackedInleftBottom0Element,
   events: {
     
   }
  });
 
 